import { Theme } from '@mui/material'

export const tableStylingMixin = (theme: Theme) => `
  & table {
    display: inline-block;
    vertical-align: top;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid ${theme.palette.grey[100]};
    border-radius: 3px;
    background-color: white;
    margin: ${theme.spacing(2.5, 1, 2.5, 2)};
    overflow: hidden;
    font-size: ${theme.typography.subtitle1.fontSize};
    line-height: ${theme.typography.subtitle1.lineHeight};
  }

  & table th, & table td {
    border-bottom: 1px solid ${theme.palette.grey[100]};
    border-right: 1px solid ${theme.palette.grey[100]};
    padding: ${theme.spacing(2.5, 2)};
    text-align: left;
  }

  & table th:last-child, & table td:last-child {
    border-right: none;
  }

  & table tbody tr:last-child td {
    border-bottom: none;
  }

  & table th {
    font-weight: 500;
  }

  & table thead {
    font-weight: ${theme.typography.subtitle1.fontWeight};
    font-size: ${theme.typography.subtitle1.fontSize};
    line-height: ${theme.typography.subtitle1.lineHeight};
  }

  & table tbody {
    font-weight: 400;
    font-size: ${theme.typography.body2.fontSize};
    line-height: ${theme.typography.body2.lineHeight};
  }

  & table:has(caption) {
    overflow: visible;
  }

  & table caption {
    color: #37474f;
    caption-side: top;
    text-align: center;
    font-weight: 400;
    border: 1px solid #e1e1e1;
    padding: 12px 16px;
    user-select: none;
  }

  & table tfoot td {
    text-align: left;
    font-weight: 400;
    padding: 12px 16px;
    user-select: none;
    border-top: 3px solid #e1e1e1;
    border-bottom: none;
  }

`

export const tableStylingMixinObj = (theme: Theme) => ({
  '& table': {
    display: 'inline-block',
    verticalAlign: 'top',
    borderCollapse: 'separate',
    borderSpacing: 0,
    border: `1px solid ${theme.palette.grey[100]}`,
    borderRadius: '3px',
    backgroundColor: 'white',
    margin: theme.spacing(2.5, 1, 2.5, 2),
    overflow: 'hidden',
    fontSize: theme.typography.subtitle1.fontSize,
    lineHeight: theme.typography.subtitle1.lineHeight,
  },

  '& table th, & table td': {
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
    borderRight: `1px solid ${theme.palette.grey[100]}`,
    padding: theme.spacing(2.5, 2),
    textAlign: 'left',
  },

  '& table th:last-child, & table td:last-child': {
    borderRight: 'none',
  },

  '& table tbody tr:last-child td': {
    borderBottom: 'none',
  },

  '& table th': {
    fontWeight: '500',
  },

  '& table thead': {
    fontWeight: '500',
    fontSize: theme.typography.subtitle1.fontSize,
    lineHeight: theme.typography.subtitle1.lineHeight,
  },

  '& table tbody': {
    fontWeight: '400',
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
  },

  '& table:has(caption)': {
    overflow: 'visible',
  },

  '& table caption': {
    color: '#37474f',
    captionSide: 'top',
    textAlign: 'center',
    fontWeight: 400,
    border: '1px solid #e1e1e1',
    padding: '12px 16px',
    userSelect: 'none',
  },

  '& table tfoot td': {
    textAlign: 'left',
    fontWeight: 400,
    padding: '12px 16px',
    userSelect: 'none',
    borderTop: '3px solid #e1e1e1',
    borderBottom: 'none',
  },
})